import React, { FC, useEffect, useLayoutEffect, useState } from "react";
import { useHttpClient, Http, UseUserAssistant, UseHttpAssistant } from "@codes-on-us/assistant";
import { toast } from "react-toastify";
import { ShowAsHTML } from '../../../utilities/common/String/ShowAsHTML';
import { UseRouteAssistant } from "../../../utilities/RouteAssistant/RouteAssistant";
import { FaSpinner } from "react-icons/fa";
import { User } from "../../../models/User";
import classes from './verification.module.scss'



const VerificationPage: FC = () => {
    const { send, isLoading } = useHttpClient();
    const { Get } = UseHttpAssistant();
    const [loading, setLoading] = useState(true);
    const { GoTo } = UseRouteAssistant();
    const [user, setUser] = useState<User>();
    const [failedSendVerification, setFailedSendVerification] = useState(false);
    const [token, setToken] = useState<string>("");

    const sendVerificationCode = async () => {
        setFailedSendVerification(false);

        const { errorMessage, response } = await send({
            url: '/Auth/SendVerificationCode',
            method: Http.POST
        });

        if (response) {
            console.log('verification response: ', response);
            const data = response as {
                value: {
                    token: string;
                };
                failed: boolean;
            };

            setToken(data?.value?.token ?? "");
        } else if (errorMessage) {
            setFailedSendVerification(true);
            toast.error(ShowAsHTML(`<div><small>${errorMessage}</small></div>`));
        }
    };

    const checkUser = async () => {
        try {
            var currentUser = (await Get("/Auth/Ping"))?.value as User;
            if (currentUser)
                setUser(currentUser)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        checkUser();
    }, []);

    useEffect(() => {
        if (user && !user.isVerified) {
            sendVerificationCode();
        }
        else if (user && user.isVerified){
            window.location.href = '/pricing';
        }
    }, [user]);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const form = event.currentTarget as HTMLFormElement;

        const emailCode = (form.elements.namedItem("emailCode") as HTMLInputElement).value;
        const phoneCode = (form.elements.namedItem("phoneCode") as HTMLInputElement).value;

        // Call API to verify the codes  
        const { errorMessage } = await send({
            url: "/Auth/VerifyVerificationCode",
            method: Http.POST,
            data: {
                emailCode,
                phoneCode,
                token
            }
        });

        if (errorMessage) {
            toast.error(ShowAsHTML(`<div><small>${errorMessage}</small></div>`));
        } else {
            window.location.href = '/pricing';
        }
    };

    return (  
        <div className={classes.module}>  
            {user && !user.isVerified ? (  
                <div className={classes.content}>  
                    <div className="text-center p50">  
                        <img src="/images/logo-dark.png" title="logo" alt="logo" />  
                    </div>  
                    {isLoading ? (  
                        <div className="text-center p50"><FaSpinner /></div>  
                    ) : !failedSendVerification ? (  
                        <p>A verification code has been sent to your email and phone number.</p>  
                    ) : (  
                        <div className={classes.errorPane}>  
                              <span>Something went wrong. Please try again.</span>  
                              <span className={classes.retryButton} onClick={sendVerificationCode}>Try again</span>
                        </div>  
                    )}
                    {!failedSendVerification && (  
                        <form onSubmit={handleSubmit}>  
                            <div className={classes.formGroup}>  
                                <label>Email verification code</label>  
                                <input  
                                    type="number"  
                                    name="emailCode"  
                                    maxLength={6}
                                    minLength={6}  
                                />  
                            </div>  
                            <div className={classes.formGroup}>  
                                <label>Phone verification code</label>  
                                <input  
                                    type="number"  
                                    name="phoneCode"  
                                    maxLength={6}
                                    minLength={6}  
                                />  
                            </div>  
                            <input type="hidden" name="token" value={token} />  
                            <button type="submit">Sign up</button>  
                        </form>  
                    )}  
                </div>  
            ) : (  
                <FaSpinner />  
            )}  
        </div>  
    );  
};

export default VerificationPage;  